import React, { FunctionComponent } from "react";
import styled from "styled-components";
import TopNavigation from "../navigation/TopNavigation";
import SidebarNavigation from "../navigation/SidebarNavigation";

export type PageWrapperProps = {
  children: JSX.Element;
};

const PageWrapper: FunctionComponent<PageWrapperProps> = (props: {
  children: JSX.Element;
}) => {
  return (
    <Root>
      <div className="navigationWrapper">
        <SidebarNavigation />
      </div>
      <div className="contentWrapper">
        <TopNavigation />
        <div className="mainContent">{props.children}</div>
      </div>
    </Root>
  );
};

export const Root = styled.div`
  display: flex;
  min-width: 100%;
  min-height: 100vh;

  & > .navigationWrapper {
    width: 300px;
    min-width: 300px;
    @media print {
      display: none;
    }
  }

  & > .contentWrapper {
    width: calc(100% - 300px);
    @media print {
      width: 100%;
    }

    & > .mainContent {
      padding: 40px;
    }
  }
`;

export default PageWrapper;
